

import React, { useEffect, ReactNode } from "react";

// react-router-dom components
import { useLocation } from "react-router-dom";
import { Theme } from "@mui/material/styles";

import MDBox from "components/MDBox";

//  context
import { useMaterialUIController, setLayout } from "context";

function DashboardLayout({ children }: { children: ReactNode }): React.JSX.Element {
  const [controller, dispatch] = useMaterialUIController();
  const { pathname } = useLocation();
  const { darkMode } = controller;
  useEffect(() => {
    setLayout(dispatch, "dashboard");
  }, [pathname]);

  return (
    <MDBox
      className={darkMode && "dark-theme"}
      sx={({ breakpoints, transitions }: Theme) => ({
        // p: 3,
        position: "relative",
        height: "100vh",
        [breakpoints.up("xl")]: {
          // marginLeft: miniSidenav ? pxToRem(120) : pxToRem(274),
          transition: transitions.create(["margin-left", "margin-right"], {
            easing: transitions.easing.easeInOut,
            duration: transitions.duration.standard,
          }),
        },
      })}
    >
      {children}
    </MDBox>
  );
}

export default DashboardLayout;
